import * as React from "react"
import styled from "styled-components"

const Wrap = ({ children, className, id }) => {
  return (
    <Wrapper className={className} id={id}>
      {children}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: var(--maxWidth-4xl);
  margin: auto;
  padding: 0 20px 50px;
  position: relative;

  @media (max-width: 1200px) {
    padding-bottom: 60px;
  }

  @media (max-width: 640px) {
    padding-bottom: 30px;
  }

  &.bottom-zero {
    padding-bottom: 0;
  }
  
`

export default Wrap
